import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./firebase";

// Bootstrap JS
import "bootstrap";

// estilos app
import "./styles/styles.scss";

import "./registerServiceWorker";

//createApp(App).use(router).mount("#app");

const app = createApp(App);
app.use(router);
app.mount("#app");
